/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

export class SellerListRequest {


    public limit: number;
    public offset: number;
    public name: string;
    public email: string;
    public status: number;
    public count: number;
    public customerId: number;
    public keyword: string;

    constructor(sellerListRequest: any) {
        ['limit', 'offset', 'name', 'email', 'status', 'count', 'customerId', 'keyword'].forEach((key) => {
            if (sellerListRequest[key]) {
                this[key] = sellerListRequest[key];
            }
        });
    }
}
